import { render, staticRenderFns } from "./VisitsRoute.vue?vue&type=template&id=4a94b0a5&scoped=true&"
import script from "./VisitsRoute.vue?vue&type=script&lang=js&"
export * from "./VisitsRoute.vue?vue&type=script&lang=js&"
import style0 from "./VisitsRoute.vue?vue&type=style&index=0&id=4a94b0a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94b0a5",
  null
  
)

export default component.exports